import {
	getPersonStatusText,
	PersonStatusColorMap,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/Documents.utils';
import type { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import type { ColumnStatusDefinition } from '@dealstack/frontend/shared/components/Table/MantineTable/ColumnDefs/StatusColumn.types';
import type { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';
import { DocumentWorkflowInstanceSignatureStatus } from '@dealstack/shared/lib/generated';

export interface SignatureStatusDisplay {
	label: string;
	color: string;
}

/**
 * Colour + label for a signature status shown to an authorised signatory on the
 * public programme signing portal. Both are sourced from the admin
 * `PersonStatusColorMap` / `getPersonStatusText` (Documents.utils) — one source of
 * truth, so the portal can't drift from the admin documents table's palette or copy.
 */
export const getProgrammeSigningStatusDisplay = (
	status: DocumentWorkflowInstanceSignatureStatus,
	tMipManage: TranslateFunction<I18Namespaces.MIP_MANAGE>
): SignatureStatusDisplay => ({
	label: getPersonStatusText(status, tMipManage),
	color: PersonStatusColorMap[status],
});

export const getProgrammeSigningStatusDefinitions = (
	tMipManage: TranslateFunction<I18Namespaces.MIP_MANAGE>
): ColumnStatusDefinition[] =>
	Object.values(DocumentWorkflowInstanceSignatureStatus).map((status) => ({
		status,
		color: PersonStatusColorMap[status],
		text: getPersonStatusText(status, tMipManage),
	}));
